// extracted by mini-css-extract-plugin
export default {"root":"Select_root__f+C3j utils_round__jRf3x"};